// extracted by mini-css-extract-plugin
export var accent = "_96-4";
export var add = "_96-j";
export var addIcon = "_96-k";
export var deleteIcon = "_96-i";
export var disabled = "_96-9";
export var ellipsis = "_96-f";
export var error = "_96-3";
export var form = "_96-5";
export var hideFocus = "_96-2";
export var icon = "_96-7";
export var input = "_96-e";
export var listItem = "_96-h";
export var mediumHeight = "_96-b";
export var noBorder = "_96-8";
export var noRadius = "_96-1";
export var shortHeight = "_96-a";
export var tallHeight = "_96-c";
export var textInput = "_96-0";
export var vertical = "_96-g";
export var veryTallHeight = "_96-d";
export var widget = "_96-6";